import accountingDocumentMenu from '@src/accounting-document/menu';
import { MenuEntry } from '@src/menu-entry';

export default [
    MenuEntry.create()
        .setTitle('Belege')
        .setChildren(accountingDocumentMenu),

    MenuEntry.create()
        .setTitle('DATEV')
        .setChildren([
            MenuEntry.create()
                .setRoute('accounting_datev_export_list')
                .setAdditionalRoutes([
                    'accounting_datev_export_create',
                    'accounting_datev_export_download',
                ]),
            MenuEntry.create()
                .setRoute('accounting_datev_export_not_exported_documents_list'),
            MenuEntry.create()
                .setRoute('document_account_statement'),
            MenuEntry.create()
                .setRoute('document_branch_account_statement'),
        ]),

    MenuEntry.create()
        .setRoute('print_invoice'),
];
